(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-plp]');
    if (!root) return;

    const grid = root.querySelector('[data-plp-grid]');
    const storageKey = 'an-plp-cols';

    const setCols = (cols) => {
      root.setAttribute('data-plp-cols-active', String(cols));
      root.querySelectorAll('[data-plp-cols]').forEach((btn) => {
        const active = btn.getAttribute('data-plp-cols') === String(cols);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      try { localStorage.setItem(storageKey, String(cols)); } catch (_) {}
    };

    try {
      const saved = localStorage.getItem(storageKey);
      if (saved === '3' || saved === '4') setCols(saved);
    } catch (_) {}

    root.querySelectorAll('[data-plp-cols]').forEach((btn) => {
      btn.addEventListener('click', () => setCols(btn.getAttribute('data-plp-cols')));
    });

    const sort = root.querySelector('[data-plp-sort]');
    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.href = url.toString();
      });
    }

    const dialog = root.querySelector('[data-plp-filters]');
    const openBtn = root.querySelector('[data-plp-filter-open]');
    const closeBtn = root.querySelector('[data-plp-filter-close]');
    if (dialog && openBtn) {
      openBtn.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        openBtn.setAttribute('aria-expanded', 'true');
      });
      const close = () => {
        dialog.close();
        openBtn.setAttribute('aria-expanded', 'false');
      };
      closeBtn?.addEventListener('click', close);
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) close();
      });
    }

    const form = root.querySelector('[data-plp-filter-form]');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const url = new URL(window.location.pathname, window.location.origin);
        const data = new FormData(form);
        for (const [key, value] of data.entries()) {
          if (value !== '') url.searchParams.append(key, value);
        }
        const sortEl = root.querySelector('[data-plp-sort]');
        if (sortEl?.value) url.searchParams.set('sort_by', sortEl.value);
        window.location.href = url.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const drawer = header.querySelector('[data-mobile-drawer]');
    const openBtn = header.querySelector('[data-menu-open]');
    const headerBar = header.querySelector('.site-header__bar');
    const mobileHeader = drawer?.querySelector('[data-mobile-header]');
    let headerPlaceholder;
    let previousOverflow;
    let mobileMenuGutter = 0;

    const nav = header.querySelector('.site-header__nav');
    let closeTimer;

    const setOpen = (open) => {
      clearTimeout(closeTimer);
      header.classList.toggle('is-open', open);
    };

    nav?.addEventListener('mouseenter', () => setOpen(true));
    nav?.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        if (drawer?.open) return;
        setOpen(false);
      }, 120);
    });

    header.querySelectorAll('[data-has-mega]').forEach((item) => {
      item.addEventListener('focusin', () => setOpen(true));
      item.addEventListener('focusout', (event) => {
        if (!nav?.contains(event.relatedTarget)) setOpen(false);
      });
    });

    const resetPanels = () => {
      drawer?.querySelectorAll('[data-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-panel') === 'root');
      });
    };

    const openDrawer = () => {
      if (!drawer || drawer.open || !headerBar || !mobileHeader) return;
      const rect = headerBar.getBoundingClientRect();
      mobileMenuGutter = window.innerWidth - rect.width;
      drawer.style.setProperty('--mobile-menu-top', rect.top + 'px');
      drawer.style.setProperty('--mobile-menu-left', rect.left + 'px');
      drawer.style.setProperty('--mobile-menu-width', rect.width + 'px');
      headerPlaceholder = document.createElement('div');
      headerPlaceholder.setAttribute('aria-hidden', 'true');
      headerPlaceholder.style.height = rect.height + 'px';
      headerBar.before(headerPlaceholder);
      mobileHeader.append(headerBar);
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      openBtn?.setAttribute('aria-expanded', 'true');
      openBtn?.setAttribute('aria-label', openBtn.dataset.closeLabel);
      resetPanels();
      setOpen(true);
      if (typeof drawer.showModal === 'function') drawer.showModal();
      openBtn?.focus({ preventScroll: true });
    };

    const restoreHeader = () => {
      if (drawer?.open) return;
      if (headerPlaceholder) {
        headerPlaceholder.replaceWith(headerBar);
        headerPlaceholder = null;
        document.documentElement.style.overflow = previousOverflow;
      }
      openBtn?.setAttribute('aria-expanded', 'false');
      openBtn?.setAttribute('aria-label', openBtn.dataset.openLabel);
      setOpen(false);
      resetPanels();
      openBtn?.focus({ preventScroll: true });
    };

    const closeDrawer = () => {
      if (!drawer) return;
      if (typeof drawer.close === 'function' && drawer.open) drawer.close();
      restoreHeader();
      openBtn?.focus({ preventScroll: true });
    };

    openBtn?.addEventListener('click', () => {
      if (drawer?.open) closeDrawer();
      else openDrawer();
    });
    drawer?.addEventListener('close', restoreHeader);
    window.matchMedia('(min-width: 990px)').addEventListener('change', event => {
      if (event.matches && drawer?.open) closeDrawer();
    });
    window.addEventListener('resize', () => {
      if (!drawer?.open) return;
      drawer.style.setProperty('--mobile-menu-width', Math.max(0, window.innerWidth - mobileMenuGutter) + 'px');
    });

    drawer?.querySelectorAll('[data-drill]').forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.getAttribute('data-drill');
        const panel = drawer.querySelector(`[data-panel="${id}"]`);
        panel?.classList.add('is-active');
        panel?.querySelector('[data-drill-back]')?.focus({ preventScroll: true });
      });
    });

    drawer?.querySelectorAll('[data-drill-back]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = button.closest('[data-panel]');
        panel?.classList.remove('is-active');
        const id = panel?.getAttribute('data-panel');
        drawer.querySelector(`[data-drill="${id}"]`)?.focus({ preventScroll: true });
      });
    });

    let coachTimer;
    let coachPending = false;
    const coachState = (state) => {
      header.querySelectorAll('[data-an-coach]').forEach((button) => {
        button.disabled = state === 'loading';
        button.setAttribute('aria-busy', String(state === 'loading'));
      });
      header.querySelectorAll('[data-coach-status]').forEach((status) => {
        status.hidden = state === 'ready';
        if (state !== 'ready') status.textContent = status.dataset[state];
      });
    };
    const openCoach = (button) => {
      if (typeof window.rep?.open !== 'function') return false;
      clearInterval(coachTimer);
      const menu = button.closest('dialog');
      if (menu?.open) menu.close();
      header.querySelectorAll('.site-header__item--mega.is-open').forEach(item => item.classList.remove('is-open'));
      button.blur();
      setOpen(false);
      requestAnimationFrame(() => requestAnimationFrame(() => {
        try {
          window.rep.show?.();
          window.rep.open();
          coachState('ready');
        } catch {
          coachState('unavailable');
        } finally {
          coachPending = false;
        }
      }));
      return true;
    };
    header.addEventListener('click', (event) => {
      const button = event.target.closest('[data-an-coach]');
      if (!button || !header.contains(button)) return;
      event.preventDefault();
      if (coachPending) return;
      coachPending = true;
      coachState('loading');
      if (openCoach(button)) return;
      const deadline = Date.now() + 20000;
      coachTimer = setInterval(() => {
        if (openCoach(button)) return;
        if (Date.now() >= deadline) {
          clearInterval(coachTimer);
          coachPending = false;
          coachState('unavailable');
        }
      }, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-hero-slideshow]');
    if (!root) return;

    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    if (!slides.length) return;

    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    const autoplay = root.dataset.autoplay === 'true';
    const speed = Number(root.dataset.autoplaySpeed || 6000);
    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;
    let timer;

    const syncVideos = (activeIndex) => {
      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (i === activeIndex) {
          video.muted = true;
          const playPromise = video.play();
          if (playPromise?.catch) playPromise.catch(() => {});
        } else {
          video.pause();
          try { video.currentTime = 0; } catch (e) {}
        }
      });
    };

    const setSlide = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((el) => {
          if (active) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });

      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      syncVideos(index);
    };

    const start = () => {
      if (slides.length < 2) return;
      if (!autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = window.setInterval(() => setSlide(index + 1), speed);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        setSlide(Number(dot.dataset.index));
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    setSlide(index);
    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product-section]');
    if (!root) return;

    const variantsEl = root.querySelector('[data-pdp-variants]');
    const moneyFormatEl = root.querySelector('[data-pdp-money-format]');
    const variantInput = root.querySelector('[data-pdp-variant-id]');
    const addBtn = root.querySelector('[data-pdp-add]');
    const priceCurrentEls = root.querySelectorAll('[data-pdp-price-current]');
    const priceCompareEl = root.querySelector('[data-pdp-price-compare]');
    const priceWasWrap = root.querySelector('.pdp__price-was');
    const qtyInput = root.querySelector('[data-pdp-qty]');
    const track = root.querySelector('[data-pdp-track]');

    let variants = [];
    let moneyFormat = '{{amount}}';
    try {
      variants = JSON.parse(variantsEl?.textContent || '[]');
    } catch (e) {
      variants = [];
    }
    try {
      moneyFormat = JSON.parse(moneyFormatEl?.textContent || '"{{amount}}"');
    } catch (e) {
      moneyFormat = '{{amount}}';
    }

    const money = (cents) => {
      const amount = (Number(cents) / 100).toFixed(2);
      const amountNoDecimals = String(Math.round(Number(cents) / 100));
      const amountWithComma = amount.replace('.', ',');
      return String(moneyFormat)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    };

    const esc = (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    const stack = (...parts) =>
      parts.filter(Boolean).map((part) => `<span class="pdp__table-stack">${esc(part)}</span>`).join('');

    const selectedOptions = () => {
      const values = [];
      root.querySelectorAll('[data-pdp-option]').forEach((el) => {
        const position = Number(el.dataset.optionPosition || 0);
        if (el.type === 'radio' && !el.checked) return;
        values[position - 1] = el.value;
      });
      return values;
    };

    const findVariant = () => {
      const opts = selectedOptions();
      return variants.find((variant) =>
        (variant.options || []).every((opt, index) => opt === opts[index])
      );
    };

    const updateVariant = () => {
      const variant = findVariant() || variants[0];
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      priceCurrentEls.forEach((el) => {
        el.textContent = money(variant.price);
      });

      if (priceCompareEl) {
        if (variant.compare_at_price > variant.price) {
          priceCompareEl.hidden = false;
          priceCompareEl.textContent = money(variant.compare_at_price);
          if (priceWasWrap) priceWasWrap.hidden = false;
        } else {
          priceCompareEl.hidden = true;
          priceCompareEl.textContent = '';
          if (priceWasWrap) priceWasWrap.hidden = true;
        }
      }

      const renderCallouts = (variant) => {
        const list = root.querySelector('[data-callouts][data-callout-surface="pdp"]');
        const dataEl = root.querySelector('[data-callout-data]');
        if (!list || !dataEl) return;
        let map = {};
        try {
          map = JSON.parse(dataEl.textContent || '{}');
        } catch (e) {
          map = {};
        }
        const items = Array.isArray(map[String(variant.id)]) ? map[String(variant.id)].slice(0, 5) : [];
        if (!items.length) {
          list.hidden = true;
          list.replaceChildren();
          return;
        }
        const iconFor = (name) => {
          const src = name ? root.querySelector(`[data-callout-icons] [data-for="${name}"]`) : null;
          return src?.innerHTML || '<span class="callout__icon callout__icon--fallback" aria-hidden="true"></span>';
        };
        list.hidden = false;
        list.innerHTML = items
          .map(
            (item) =>
              `<li class="callout">${iconFor(item.icon)}<span class="callout__label">${esc(item.label)}</span></li>`
          )
          .join('');
      };
      renderCallouts(variant);

      const nutritionTablesEl = root.querySelector('[data-pdp-nutrition-tables]');
      let nutritionTables = {};
      try {
        nutritionTables = JSON.parse(nutritionTablesEl?.textContent || '{}');
      } catch (e) {
        nutritionTables = {};
      }
      const nutritionWrap = root.querySelector('[data-pdp-nutrition-wrap]');
      const nutritionData = nutritionTables[String(variant.id)];
      if (nutritionWrap && nutritionData) {
        const body = nutritionWrap.querySelector('[data-nutrition-body]');
        const h100 = nutritionWrap.querySelector('[data-nutrition-h100]');
        const hServing = nutritionWrap.querySelector('[data-nutrition-hserving]');
        if (h100) h100.textContent = nutritionData.header_100 || '';
        if (hServing) hServing.textContent = nutritionData.header_serving || '';
        if (body) {
          body.innerHTML = (nutritionData.rows || [])
            .map((row) => {
              const classes = [
                row.kind === 'child' ? 'pdp__table-row--child' : '',
                row.kind === 'parent' ? 'pdp__table-row--parent' : '',
                row.group ? 'pdp__table-row--group' : '',
              ]
                .filter(Boolean)
                .join(' ');
              if (row.kind === 'energy') {
                return `<tr class="${classes}"><th scope="row">${esc(row.label)}</th><td class="pdp__table-num">${stack(row.per_100_kj, row.per_100_kcal)}</td><td class="pdp__table-num">${stack(row.per_serving_kj, row.per_serving_kcal)}</td></tr>`;
              }
              return `<tr class="${classes}"><th scope="row">${esc(row.label)}</th><td class="pdp__table-num">${esc(row.per_100 || '–')}</td><td class="pdp__table-num">${esc(row.per_serving || '–')}</td></tr>`;
            })
            .join('');
        }
      }

      if (addBtn) {
        const label = addBtn.querySelector('[data-pdp-add-label]');
        addBtn.disabled = !variant.available;
        if (!variant.available) {
          addBtn.textContent = addBtn.dataset.soldOutLabel || 'Sold out';
        } else if (label) {
          label.textContent = addBtn.dataset.inStockLabel || 'Add to basket';
        }
      }

      const galleriesEl = root.querySelector('[data-pdp-variant-galleries]');
      let galleries = {};
      try {
        galleries = JSON.parse(galleriesEl?.textContent || '{}');
      } catch (e) {
        galleries = {};
      }
      const galleryUrls = galleries[String(variant.id)] || [];
      if (galleryUrls.length && track) {
        const slides = [...track.querySelectorAll('[data-pdp-slide]')];
        slides.forEach((slide, index) => {
          const img = slide.querySelector('.pdp__image');
          const url = galleryUrls[index];
          if (img && url) img.src = url;
        });
        slides[0]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      } else if (variant.featured_media?.id && track) {
        const slide = track.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      } else if (variant.featured_image && track) {
        const firstImg = track.querySelector('.pdp__image');
        if (firstImg && variant.featured_image.src) {
          const url = variant.featured_image.src;
          firstImg.src = url.includes('?') ? `${url}&width=1400` : `${url}?width=1400`;
        }
      }
    };

    root.querySelectorAll('[data-pdp-option]').forEach((el) => {
      el.addEventListener('change', updateVariant);
    });

    root.querySelectorAll('[data-pdp-size-select]').forEach((select) => {
      const formatSizeMeta = (raw) => {
        const value = String(raw || '').trim();
        const sizePart = value.split('(')[0].trim() || value;
        const servingsMatch = value.match(/\((\d+)\s*servings?\)/i);
        const servings = servingsMatch ? servingsMatch[1] : 'XX';
        return `${servings} Servings / ${sizePart}`;
      };

      const meta = select.closest('.pdp__option')?.querySelector('[data-pdp-size-meta]');
      if (meta) meta.textContent = formatSizeMeta(select.value);

      select.addEventListener('change', () => {
        if (!meta) return;
        meta.textContent = formatSizeMeta(select.value);
      });
    });

    const syncFlavourTrigger = (dropdown, value) => {
      const optionBtn = dropdown.querySelector(`[data-pdp-dropdown-option][data-value="${CSS.escape(value)}"]`);
      const swatch = dropdown.querySelector('[data-pdp-dropdown-swatch]');
      const label = dropdown.querySelector('[data-pdp-dropdown-value]');
      const select = dropdown.querySelector('[data-pdp-flavour-select]');
      if (label) label.textContent = value;
      if (swatch && optionBtn) swatch.style.background = optionBtn.dataset.swatch || '#90a4ae';
      if (select) select.value = value;
      dropdown.querySelectorAll('[data-pdp-dropdown-option]').forEach((btn) => {
        const selected = btn.dataset.value === value;
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      select?.dispatchEvent(new Event('change', { bubbles: true }));
    };

    root.querySelectorAll('[data-pdp-dropdown]').forEach((dropdown) => {
      const trigger = dropdown.querySelector('[data-pdp-dropdown-trigger]');
      const list = dropdown.querySelector('[data-pdp-dropdown-list]');
      const select = dropdown.querySelector('[data-pdp-flavour-select]');
      if (!trigger || !list) return;

      if (select) syncFlavourTrigger(dropdown, select.value);

      trigger.addEventListener('click', () => {
        const open = list.hasAttribute('hidden');
        list.toggleAttribute('hidden', !open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      list.querySelectorAll('[data-pdp-dropdown-option]').forEach((btn) => {
        btn.addEventListener('click', () => {
          syncFlavourTrigger(dropdown, btn.dataset.value);
          list.setAttribute('hidden', '');
          trigger.setAttribute('aria-expanded', 'false');
        });
      });
    });

    document.addEventListener('click', (event) => {
      root.querySelectorAll('[data-pdp-dropdown]').forEach((dropdown) => {
        if (dropdown.contains(event.target)) return;
        const list = dropdown.querySelector('[data-pdp-dropdown-list]');
        const trigger = dropdown.querySelector('[data-pdp-dropdown-trigger]');
        if (list) list.setAttribute('hidden', '');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    });

    root.querySelectorAll('[data-qty-change]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const next = Math.max(1, Number(qtyInput.value || 1) + Number(btn.dataset.qtyChange || 0));
        qtyInput.value = String(next);
      });
    });

    const scrollCarousel = (dir) => {
      if (!track) return;
      const slide = track.querySelector('.pdp__slide');
      const amount = slide ? slide.getBoundingClientRect().width : track.clientWidth * 0.85;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };

    root.querySelector('[data-pdp-prev]')?.addEventListener('click', () => scrollCarousel(-1));
    root.querySelector('[data-pdp-next]')?.addEventListener('click', () => scrollCarousel(1));

    updateVariant();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KEY = 'an-recently-viewed';
    const section = document.querySelector('[data-recently-viewed]');
    if (!section) return;

    const limit = Number(section.getAttribute('data-limit') || 8);
    const track = section.querySelector('[data-rv-track]');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    let handles = [];
    try {
      const raw = localStorage.getItem(KEY);
      const list = raw ? JSON.parse(raw) : [];
      handles = (Array.isArray(list) ? list : []).slice(0, limit);
    } catch (_) {}

    if (!handles.length) {
      if (track.querySelector('[data-rv-fallback]')) section.hidden = false;
      return;
    }

    Promise.all(
      handles.map(async (handle) => {
        try {
          const res = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=product-card-ajax`);
          if (!res.ok) return null;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const card = doc.querySelector('.product-card');
          return card;
        } catch (_) {
          return null;
        }
      })
    ).then((cards) => {
      const valid = cards.filter(Boolean);
      if (!valid.length) {
        if (track.querySelector('[data-rv-fallback]')) section.hidden = false;
        return;
      }
      track.innerHTML = '';
      valid.forEach((card) => {
        const item = document.createElement('div');
        item.className = 'recently-viewed__item';
        item.appendChild(card);
        track.appendChild(item);
      });
      section.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.plp--search[data-plp]');
    if (!root) return;
    const storageKey = 'an-plp-cols';
    const setCols = (cols) => {
      root.setAttribute('data-plp-cols-active', String(cols));
      root.querySelectorAll('[data-plp-cols]').forEach((btn) => {
        const active = btn.getAttribute('data-plp-cols') === String(cols);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      try { localStorage.setItem(storageKey, String(cols)); } catch (_) {}
    };
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved === '3' || saved === '4') setCols(saved);
    } catch (_) {}
    root.querySelectorAll('[data-plp-cols]').forEach((btn) => {
      btn.addEventListener('click', () => setCols(btn.getAttribute('data-plp-cols')));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.tabbed-products');
    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('[role="tab"]');
      var panels = section.querySelectorAll('[role="tabpanel"]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = this.getAttribute('data-tab-index');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', '');
          });

          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');
          panels[index].classList.add('is-active');
          panels[index].removeAttribute('hidden');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
